import React from 'react'

const ManagementContext = React.createContext({})

export default ManagementContext